// Zoom threshold below which quick view is enabled
export const QUICK_VIEW_ZOOM_THRESHOLD = 0.5;
